import { localesMap } from "../consts/localesMap";

export function	createLocalePredicate(locale: string) {
	return (item: { node_locale: string }) => item.node_locale === localesMap[locale];
};